import S from "../pages/Product/style";

const data = [
  {
    category: {
      id: 5,
      name: "2015",
      imgsrc: [process.env.PUBLIC_URL + "/images/category/2015.jpeg"],
      content:
        "Kuru Kimyevi Tozlu, Karbondioksitli, Köpüklü, Sulu yangın söndürme cihazları.",
      link: "/category/2015/5/subcategories",
      subcategories: [
        {
          id: 0,
          name: "Haziran",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Haziran/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Haziran/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Haziran/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Haziran/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Haziran/5.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Haziran/6.jpg",
          ],
          content: "",
          link: "/product/5/0/haziran",
          detail: (
            <div className="detail">
              <h3>Prof. Dr. Erol TAVMERGEN</h3>
              <article>Konu: YÜT'DE GÜNCEL YAKLAŞIMLAR</article>
            </div>
          ),
        },
        {
          id: 1,
          name: "Temmuz",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Temmuz/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Temmuz/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Temmuz/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Temmuz/4.jpg",
          ],
          link: "/product/5/1/temmuz",
          detail: (
            <div className="detail">
              <h3>Dr. Mustafa Kemal ÖZEL</h3>
              <article>Konu : GİRİŞİMSEL OLMAYAN PRENATAL TANI</article>
            </div>
          ),
        },
        {
          id: 2,
          name: "Ağustos",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Agustos/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Agustos/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Agustos/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Agustos/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Agustos/5.jpg",
          ],
          link: "/product/5/2/agustos",
          detail: (
            <div className="detail">
              <h3>Dr.Tonguç GÜNDÜZ</h3>
              <article>
                Konu : SPERM KALİTESİ:HANGİ DURUMDA HANGİ TEDAVİ ?
              </article>
              <h3>Yrd. Doç.Esra Nur TOLA</h3>
              <article>Konu : OHSS</article>
            </div>
          ),
        },
        {
          id: 3,
          name: "Eylül",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Eylul/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Eylul/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Eylul/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Eylul/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Eylul/5.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Eylul/6.jpg",
          ],
          link: "/product/5/3/eylul",
          detail: (
            <div className="detail">
              <h3>Prof. Dr.Münire ERMAN AKAR</h3>
              <article>
                Konu : FERTİLİTE PREZERVASYONU İÇİN ENDİKASYONLAR VE GÜVENLİ
                TEDAVİ PROTOKOLLERİ
              </article>
            </div>
          ),
        },
        {
          id: 4,
          name: "Ekim",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Ekim/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Ekim/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Ekim/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Ekim/4.jpg",
          ],
          link: "/product/5/4/ekim",
          detail: (
            <div className="detail">
              <h3>Dr.Figen DEMİR</h3>
              <article>Konu : HASTA YÖNETİMİ</article>
              <h3>Dr.Barış MÜLAYİM</h3>
              <article>Konu : İNFERTİLİTEDE ENDOSKOPİNİN YERİ</article>
            </div>
          ),
        },
        {
          id: 5,
          name: "Kasım",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Kasim/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Kasim/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Kasim/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Kasim/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Kasim/5.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Kasim/6.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Kasim/7.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Kasim/8.jpg",
          ],
          link: "/product/5/5/kasim",
          detail: (
            <div className="detail">
              <h3>Dr.Barış ATA</h3>
              <article>Konu : İNFERTİLİTEDE YAPILMAMASI GEREKENLER</article>
              <h3>Dr.Batu AYDINURAZ</h3>
              <article>Konu : İNFERTİL HASTALARA GENEL YAKLAŞIM</article>
            </div>
          ),
        },
        {
          id: 6,
          name: "Aralık",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Aralik/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Aralik/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Aralik/3.jpg",
          ],
          link: "/product/5/6/aralik",
          detail: (
            <div className="detail">
              <h3>Jinekolog Onkolog Tayfun TOPTAŞ</h3>
              <article>Konu : ONKOLOJİDE ROBOTİK CERRAHİNİN YERİ</article>
              <h3>Prof. Dr.Aysel DERBENT UYSAL</h3>
              <article>Konu : JİNEKOLOJİDE ROBOTİK CERRAHİNİN YERİ</article>
              <h3>Dr.Ünal YİRMİBEŞ</h3>
              <article>Konu : NON-SELEKTİF L\S HİSTEREKTOMİ</article>
            </div>
          ),
        },
      ],
    },
  },
  {
    category: {
      id: 6,
      name: "2016",
      imgsrc: [process.env.PUBLIC_URL + "/images/category/2016.jpeg"],
      content:
        "Kuru Kimyevi Tozlu, Karbondioksitli, Köpüklü, Sulu yangın söndürme cihazları.",
      link: "/category/2016/6/subcategories",
      subcategories: [
        {
          id: 0,
          name: "Ocak",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Ocak/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Ocak/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Ocak/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Ocak/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Ocak/5.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Ocak/6.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Ocak/7.jpg",
          ],
          content: "",
          link: "/product/6/0/ocak",
          detail: (
            <div className="detail">
              <h3>Prof. Dr.N.Erkut ATTAR</h3>
              <article>Konu : ENDOMETRİOZİSTE MEDİKAL YAKLAŞIM</article>
              <h3>Prof. Dr.Tayup ŞİMŞEK</h3>
              <article>Konu : ENDOMETRİOZİSTE CERRAHİ YAKLAŞIM</article>
            </div>
          ),
        },
        {
          id: 1,
          name: "Şubat",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Subat/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Subat/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Subat/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Subat/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Subat/5.jpg",
          ],
          link: "/product/6/1/subat",
          detail: (
            <div className="detail">
              <h3>Prof. Dr.Batuhan ÖZMEN (Ankara Ünv.)</h3>
              <article>Konu : REPRODÜKTİF CERRAHİ</article>
              <h3>Doç. Dr.Gürkan BOZDAĞ (Hacettepe Ünv.)</h3>
              <article>Konu : TÜRKİYE'DE PCOS PREVALANSI</article>
            </div>
          ),
        },
        {
          id: 2,
          name: "Nisan",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Nisan/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Nisan/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Nisan/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Nisan/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Nisan/5.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Nisan/6.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Nisan/7.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/Nisan/8.jpg",
          ],
          link: "/product/6/2/nisan",
          detail: (
            <div className="detail">
              <h3>TBMD / Her Yönüyle OHSS Sempozyumu</h3>
            </div>
          ),
        },
        {
          id: 3,
          name: "Haziran",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Haziran/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Haziran/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Haziran/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Haziran/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Haziran/5.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Haziran/6.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Haziran/7.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Haziran/8.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Haziran/9.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Haziran/10.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Haziran/11.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Haziran/12.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Haziran/13.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Haziran/14.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Haziran/15.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Haziran/16.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Haziran/17.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Haziran/18.jpg",
          ],
          link: "/product/6/3/haziran",
          detail: (
            <div className="detail">
              <h3>Hemşire Toplantısı</h3>
              <article>
                Konu : İNTERTİLİTE HEMŞİRELİĞİNDE GÜNCEL YAKLAŞIM
              </article>
              <h3>Doç. Dr.Samet Topuz</h3>
              <article>
                Konu : SERVİKAL PREİNVAZİV HASTALIKLARA YÖNETİM.TARAMADA NELER
                DEĞİŞTİ, HPV Mİ SMEAR Mİ ?
              </article>
              <h3>Doç. Dr.Pınar Çilesiz Göksedef</h3>
              <article>
                Konu : SERVİKAL PREİNVAZİV LEZYONLARIN DEĞERLENDİRMESİNDE
                KOLPOSKOPİ. KOLPOSKOPİK PATOLOJİLERDE YENİ NELER VAR, DAHA
                OBJEKTİF NASIL OLUNUR ?
              </article>
            </div>
          ),
        },
        {
          id: 4,
          name: "Eylül",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Eylul/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Eylul/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Eylul/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Eylul/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Eylul/5.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Eylul/6.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Eylul/7.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Eylul/8.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Eylul/9.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Eylul/10.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Eylul/11.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Eylul/12.jpg",
          ],
          link: "/product/6/4/eylul",
          detail: (
            <div className="detail">
              <h3>Prof. Dr.Selahattin KUMRU (Akdeniz Ünv.)</h3>
              <article>Konu : GEBELİKTE DİABET TARAMASI</article>
              <h3>Prof. Dr.Özgür DÜNDAR (Maltepe Ünv.)</h3>
              <article>
                Konu : SERVİKS UZUNLUĞUNUN ÖLÇÜMÜ VE KISA SERVİKSE YAKLAŞIM
              </article>
            </div>
          ),
        },
        {
          id: 5,
          name: "Ekim",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Ekim/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Ekim/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Ekim/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Ekim/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Ekim/5.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Ekim/6.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Ekim/7.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Ekim/8.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Ekim/9.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Ekim/10.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Ekim/11.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Ekim/12.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Ekim/13.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Ekim/14.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Ekim/15.jpg",
          ],
          link: "/product/6/5/ekim",
          detail: (
            <div className="detail">
              <h3>Prof. Dr.Mehmet YILMAZER (Kocatepe Ünv.)</h3>
              <article>
                Konu : MİNİMAL İNVAZİV LAPAROSKOPİK HİSTEREKTOMİ
              </article>
              <h3>Prof. Dr.Mete GÜNGÖR (Acıbadem Ünv.)</h3>
              <article>Konu : ROBOTİK CERRAHİ</article>
            </div>
          ),
        },
        {
          id: 6,
          name: "Kasım",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Kasim/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Kasim/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Kasim/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Kasim/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Kasim/5.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Kasim/6.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Kasim/7.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Kasim/8.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Kasim/9.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Kasim/10.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Kasim/11.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Kasim/12.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Kasim/13.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Kasim/14.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Kasim/15.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Kasim/16.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Kasim/17.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Kasim/18.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Kasim/19.jpg",
          ],
          link: "/product/6/6/kasim",
          detail: (
            <div className="detail">
              <h3>Prof. Dr.Recep HAS (İst. Ünv.)</h3>
              <article>Konu : PRENATAL TANI: DÜNÜ BUGÜNÜ YARINI</article>
              <h3>Prof. Dr.Muhterem BAHÇE (Gen Lab. Ank.)</h3>
              <article>Konu : PRENATAL TANI YÖNTEMLERİ</article>
            </div>
          ),
        },
        {
          id: 7,
          name: "Aralık",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Aralik/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Aralik/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Aralik/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Aralik/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Aralik/5.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Aralik/6.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Aralik/7.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Aralik/8.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Aralik/9.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Aralik/10.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Aralik/11.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2016-Aralik/12.jpg",
          ],
          link: "/product/6/7/aralik",
          detail: (
            <div className="detail">
              <h3>Dr.Mehmet ÖZTÜRKMEN</h3>
              <article>Konu : KLİNİSYEN GÖZÜYLE HSG</article>
            </div>
          ),
        },
      ],
    },
  },
  {
    category: {
      id: 7,
      name: "2017",
      imgsrc: [process.env.PUBLIC_URL + "/images/category/2017.jpeg"],
      content:
        "Kuru Kimyevi Tozlu, Karbondioksitli, Köpüklü, Sulu yangın söndürme cihazları.",
      link: "/category/2017/7/subcategories",
      subcategories: [
        {
          id: 0,
          name: "Ocak",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Ocak/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Ocak/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Ocak/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Ocak/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Ocak/5.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Ocak/6.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Ocak/7.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Ocak/8.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Ocak/9.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Ocak/10.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Ocak/11.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Ocak/12.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Ocak/13.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Ocak/14.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Ocak/15.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Ocak/16.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Ocak/17.jpg",
          ],
          content: "",
          link: "/product/7/0/ocak",
          detail: (
            <div className="detail">
              <h3>Prof. Dr.Kutay BİBEROĞLU</h3>
              <article>
                Konu : TÜM YÖNLERİYLE ÜREME TIBBI. DÜNYADA VE TÜRKİYE'DE DURUM
                NEDİR ?
              </article>
              <h3>Prof. Dr.Ahmet Zeki IŞIK</h3>
              <article>Konu : OOSİT KRİYOPREZERVASYONUNDA NERDEYİZ ?</article>
              <h3>Doç. Dr.Kubilay VİCDAN</h3>
              <article>
                Konu : KÖTÜ OVER REZERVİNDE OOSİT DONDURMA GEÇERLİ BİR
                ENDİKASYON MUDUR ?
              </article>
            </div>
          ),
        },
        {
          id: 1,
          name: "Şubat",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Subat/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Subat/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Subat/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Subat/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Subat/5.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Subat/6.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Subat/7.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Subat/8.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Subat/9.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Subat/10.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Subat/11.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Subat/12.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Subat/13.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Subat/14.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Subat/15.jpg",
          ],
          link: "/product/7/1/subat",
          detail: (
            <div className="detail">
              <h3>Prof. Dr.Önay YALÇIN</h3>
              <article>
                Konu : ÜRİNER İNKONTİNANS VE PELVİK ORGAN PROLAPSUSUNDA
                DEĞERLENDİRME ALGORİTMALARI: UYGULAMADA EKSİKLER VE
                YANLIŞLARIMIZ...
              </article>
              <h3>Doç. Dr.Funda Güngör UĞUR</h3>
              <article>
                Konu : KONSERVATİF TEDAVİLER: NE ZAMAN ? NASIL ?
              </article>
              <h3>Prof. Dr.Fuat DEMİRCİ</h3>
              <article>
                Konu : CERRAHİ TEDAVİLER: HANGİ HASTAYA, HANGİ YÖNTEM ?
              </article>
            </div>
          ),
        },
        {
          id: 2,
          name: "Mart",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Mart/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Mart/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Mart/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Mart/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Mart/5.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Mart/6.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Mart/7.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Mart/8.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Mart/9.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Mart/10.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Mart/11.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Mart/12.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Mart/13.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Mart/14.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Mart/15.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Mart/16.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Mart/17.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Mart/18.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Mart/19.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Mart/20.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Mart/21.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Mart/22.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Mart/23.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Mart/24.jpg",
          ],
          link: "/product/7/2/mart",
          detail: (
            <div className="detail">
              <h3>Prof. Dr.Cem Somer ATABEKOĞLU</h3>
              <article>Konu : POLİKİSTİK OVERDE OVÜLASYON İNDÜKSİYONU</article>
              <h3>Doç. Dr.Salih TAŞKIN</h3>
              <article>
                Konu : FERTİLİTE KORUYUCU JİNEKOLOJİK KANSER CERRAHİSİ
              </article>
            </div>
          ),
        },
        {
          id: 3,
          name: "Nisan",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Nisan/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Nisan/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Nisan/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Nisan/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Nisan/5.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Nisan/6.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Nisan/7.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Nisan/8.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Nisan/9.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Nisan/10.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Nisan/11.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Nisan/12.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Nisan/13.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Nisan/14.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Nisan/15.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Nisan/16.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Nisan/17.jpg",
          ],
          link: "/product/7/3/nisan",
          detail: (
            <div className="detail">
              <h3>Doç. Dr.Murat ÖZEKİNCİ</h3>
              <article>Konu : POI VE POF : TANI VE GÜNCEL YAKLAŞIM</article>
              <h3>Doç. Dr.Nasuh Utku DOĞAN</h3>
              <article>
                Konu : HRT VE KANSER İLİŞKİSİ: KİME, NE ZAMAN, NE KADAR SÜRE ?
              </article>
            </div>
          ),
        },
        {
          id: 4,
          name: "Haziran",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Haziran/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Haziran/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Haziran/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Haziran/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Haziran/5.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Haziran/6.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Haziran/7.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Haziran/8.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Haziran/9.jpg",
          ],
          link: "/product/7/4/haziran",
          detail: (
            <div className="detail">
              <h3>Doç. Dr.İbrahim KALELİOĞLU</h3>
              <article>Konu : İLK ÜÇ AY SONOGRAFİSİ</article>
              <h3>Prof. Dr.Atıl YÜKSEL</h3>
              <article>Konu : FETAL NÖROSONOGRAFİ</article>
            </div>
          ),
        },
        {
          id: 7,
          name: "Aralık",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Aralik/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Aralik/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Aralik/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Aralik/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Aralik/5.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Aralik/6.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Aralik/7.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Aralik/8.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Aralik/9.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2017-Aralik/10.jpg",
          ],
          link: "/product/7/7/aralik",
          detail: (
            <div className="detail">
              <h3>Doç. Dr.C.Mutlu ERCAN</h3>
              <article>
                Konu : Tekrarlayan gebelik kaybı "değerlendirme"
              </article>
              <h3>Doç. Dr.Mehmet SAKINCI</h3>
              <article>Konu : Tekrarlayan gebelik kaybı "yönetim"</article>
            </div>
          ),
        },
      ],
    },
  },
  {
    category: {
      id: 8,
      name: "2018",
      imgsrc: [process.env.PUBLIC_URL + "/images/category/2018.jpeg"],
      content:
        "Kuru Kimyevi Tozlu, Karbondioksitli, Köpüklü, Sulu yangın söndürme cihazları.",
      link: "/category/2018/8/subcategories",
      subcategories: [
        {
          id: 0,
          name: "Ocak",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Ocak/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Ocak/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Ocak/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Ocak/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Ocak/5.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Ocak/6.jpg",
          ],
          content: "",
          link: "/product/8/0/ocak",
          detail: (
            <div className="detail">
              <h3>Dr.Funda GÜNGÖR UĞURLUCAN</h3>
              <article>
                Konu : Cinsel ağrı bozukluklarında jinekoloğun yeri ve tedavi
                modaliteleri
              </article>
              <h3>Dr.Süleyman Engin AKHAN</h3>
              <article>
                Konu : Hipertonik pelvik taban bozuklukları ve cinsellik üzerine
                etkileri
              </article>
            </div>
          ),
        },

        {
          id: 2,
          name: "Mart",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Mart/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Mart/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Mart/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Mart/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Mart/5.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Mart/6.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Mart/7.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Mart/8.jpg",
          ],
          link: "/product/8/2/mart",
          detail: (
            <div className="detail">
              <h3>PANEL - Üreme Tedavilerinde Akla Takılanlar</h3>
              <article>
                PANEL - Üreme Tedavilerinde Akla Takılanlar Dr. Batu AYDINURAZ -
                Dr. Emb. Enver Kerem DİRİCAN - Dr. Tonguç GÜNDÜZ - Dr. Mete
                IŞIKOĞLU Dr. Murat ÖZEKİNCİ - Dr. Mehmet ÖZTÜRKMEN
              </article>
            </div>
          ),
        },
        {
          id: 3,
          name: "Nisan",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Nisan/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Nisan/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Nisan/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Nisan/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Nisan/5.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Nisan/6.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Nisan/7.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Nisan/8.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Nisan/9.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Nisan/10.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Nisan/11.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Nisan/12.jpg",
          ],
          link: "/product/8/3/nisan",
          detail: (
            <div className="detail">
              <h3>Doç.Dr.And YAVUZ</h3>
              <article>Konu : 1.Trimester Fetal Anomali Taraması</article>
              <h3>Prof.Dr.Evrim ERDEMOĞLU</h3>
              <article>Konu : Laparoskopik Histerektomide Püf Noktalar</article>
            </div>
          ),
        },
        {
          id: 4,
          name: "Haziran",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Haziran/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Haziran/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Haziran/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Haziran/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Haziran/5.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Haziran/6.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Haziran/7.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Haziran/8.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Haziran/9.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Haziran/10.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Haziran/11.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Haziran/12.jpg",
          ],
          link: "/product/8/4/haziran",
          detail: (
            <div className="detail">
              <h3>Doç.Dr.Volkan TURAN</h3>
              <article>
                Konu : İntrauterin İnseminasyon'da Başarılı Olmanın Sırları
              </article>
              <h3>Doç.Dr.Şafak OLGAN</h3>
              <article>
                Konu : Açıklanamayan İnfertiliteye Güncel Yaklaşım
              </article>
            </div>
          ),
        },
        {
          id: 7,
          name: "Eylül",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Eylul/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Eylul/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Eylul/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Eylul/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Eylul/5.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Eylul/6.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Eylul/7.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Eylul/8.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Eylul/9.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Eylul/10.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Eylul/11.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Eylul/12.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Eylul/13.jpg",
          ],
          link: "/product/8/7/eylul",
          detail: (
            <div className="detail">
              <h3>Prof.Dr.Serdar GÜNALP</h3>
              <article>Konu : IUI:Kritik Analiz</article>
              <h3>Prof.Dr.Esat ORHON</h3>
              <article>Konu : İnfertilitede Ezber Bozan Realiteler</article>
            </div>
          ),
        },
        {
          id: 8,
          name: "Kasım",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Kasim/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Kasim/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Kasim/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Kasim/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Kasim/5.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Kasim/6.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Kasim/7.jpg",
          ],
          link: "/product/8/8/kasim",
          detail: (
            <div className="detail">
              <h3>Doç.Dr.Kemal ÖZERKAN</h3>
              <article>
                Konu : Laparoskopinin trikleri; Görsel sunumlar eşliğinde
                tartışma
              </article>
              <h3>Prof.Dr.Gürkan UNCU</h3>
              <article>
                Konu : Biz infertil çifte nasıl yaklaşıyoruz ? Tanı ve tedaviye
                minimal yaklaşım ?
              </article>
            </div>
          ),
        },
        {
          id: 9,
          name: "Aralık",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Aralik/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Aralik/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Aralik/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Aralik/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Aralik/5.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Aralik/6.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Aralik/7.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Aralik/8.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Aralik/9.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Aralik/10.jpg",
          ],
          link: "/product/8/9/aralik",
          detail: (
            <div className="detail">
              <h3>Prof.Dr.Mahmut Tuncay ÖZGÜN</h3>
              <article>Konu : Sezaryen skar gebeliği</article>
              <h3>Prof.Dr.Selim BÜYÜKKURT</h3>
              <article>
                Konu : İyi bir ultrason görüntüsü için cihaz ayarları
              </article>
            </div>
          ),
        },
      ],
    },
  },
  {
    category: {
      id: 9,
      name: "2019",
      imgsrc: [process.env.PUBLIC_URL + "/images/category/2019.jpeg"],
      content:
        "Kuru Kimyevi Tozlu, Karbondioksitli, Köpüklü, Sulu yangın söndürme cihazları.",
      link: "/category/2019/9/subcategories",
      subcategories: [
        {
          id: 0,
          name: "Mart",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Mart/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Mart/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Mart/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Mart/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Mart/5.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Mart/6.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Mart/7.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Mart/8.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Mart/9.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Mart/10.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Mart/11.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Mart/12.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Mart/13.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Mart/14.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Mart/15.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Mart/16.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Mart/17.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Mart/18.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Mart/19.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Mart/20.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Mart/21.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Mart/22.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Mart/23.jpg",
          ],

          content: "",
          link: "/product/9/0/mart",
          detail: (
            <div className="detail">
              <h3>Prof.Dr.Ahmet Zeki IŞIK</h3>
              <article>
                Konu : Üremeye yardımcı tedavilerde 26 yılda nereden nereye
                geldik ? Sevdalı bir yolculuğun kişisel notları
              </article>
              <h3>Doç.Dr.Kubilay VİCDAN</h3>
              <article>Konu : IVF uygulamalarında sıradışı deneyimler</article>
              <h3>Tahsin Cüneyt BALIKÇIOĞLU</h3>
              <article>Konu : Buzuldan denize kıtaların doğası</article>
            </div>
          ),
        },

        {
          id: 2,
          name: "Mayıs",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Mayıs/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Mayıs/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Mayıs/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Mayıs/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Mayıs/5.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Mayıs/6.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Mayıs/7.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Mayıs/8.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Mayıs/9.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Mayıs/10.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Mayıs/11.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Mayıs/12.jpg",
          ],
          link: "/product/9/2/mayıs",
          detail: (
            <div className="detail">
              <h3>Prof.Dr.Erkut ATTAR</h3>
              <article>
                Konu : Endometrioziste profilaktik tedavi mümkün mü?
              </article>
              <h3>Doç.Dr.Mehmet SAKINCI</h3>
              <article>
                Konu : Endometriozis Kronik Pelvik Ağrı İlişkisi
              </article>
              <h3>Uzm.Fzt.Alime BÜYÜK GÖNEN</h3>
              <article>
                Konu : Endometrioziste Pelvik Taban Rehabilitasyonu
              </article>
            </div>
          ),
        },
        {
          id: 3,
          name: "Eylül",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Eylul/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Eylul/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Eylul/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Eylul/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Eylul/5.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Eylul/6.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Eylul/7.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Eylul/8.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Eylul/9.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Eylul/10.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Eylul/11.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Eylul/12.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Eylul/13.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Eylul/14.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Eylul/15.jpg",
          ],
          link: "/product/9/3/eylul",
          detail: (
            <div className="detail">
              <h3>Psikoterapist Gülsen KARABACAK</h3>
              <article>
                Konu : Psikodinamik bakış açısı ile Vaginismusun anlamı
              </article>
              <h3>Op.Dr. Dilek ÖCAL</h3>
              <article>
                Konu : Jinekolojik temelde Vaginismusun tedavisi
              </article>
              <h3>Op.Dr. N.Umut ÖZDEMİR</h3>
              <article>
                Konu : Tedavi sürecinde Vaginismus erkeğinin yönetimi
              </article>
            </div>
          ),
        },
        {
          id: 4,
          name: "Ekim",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Ekim/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Ekim/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Ekim/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Ekim/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Ekim/5.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Ekim/6.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Ekim/7.jpg",
          ],
          link: "/product/9/4/ekim",
          detail: (
            <div className="detail">
              <h3>Doç.Dr. Aysel UYSAL</h3>
              <article>Konu : Kadın infertilitesinde fito terapi</article>
              <h3>Prof.Dr. Alim KOŞAR</h3>
              <article>
                Konu : Erkek infertilitesinde tamamlayıcı ve bitkisel tedaviler
              </article>
            </div>
          ),
        },
        {
          id: 7,
          name: "Eylül",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Eylul/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Eylul/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Eylul/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Eylul/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Eylul/5.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Eylul/6.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Eylul/7.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Eylul/8.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Eylul/9.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Eylul/10.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Eylul/11.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Eylul/12.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2018-Eylul/13.jpg",
          ],
          link: "/product/8/7/eylul",
          detail: (
            <div className="detail">
              <h3>Prof.Dr.Serdar GÜNALP</h3>
              <article>Konu : IUI:Kritik Analiz</article>
              <h3>Prof.Dr.Esat ORHON</h3>
              <article>Konu : İnfertilitede Ezber Bozan Realiteler</article>
            </div>
          ),
        },
        {
          id: 8,
          name: "Kasım",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Kasim/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Kasim/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Kasim/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Kasim/4.jpg",
          ],
          link: "/product/9/8/kasim",
          detail: (
            <div className="detail">
              <h3>Prof.Dr. Bülent TIRAŞ</h3>
              <article>
                Konu : IVF te endometrial sıvının önemi nedir ? Nasıl çözüm
                bulalım.
              </article>
              <h3>Prof.Dr. Hulusi Bülent ZEYNELOĞLU</h3>
              <article>
                Konu : Tekrarlayan başarısızlıklarda adjuvan tedaviler
              </article>
            </div>
          ),
        },
        {
          id: 9,
          name: "Aralık",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Aralik/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Aralik/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Aralik/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Aralik/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Aralik/5.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Aralik/6.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Aralik/7.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2019-Aralik/8.jpg",
          ],
          link: "/product/9/9/aralik",
          detail: (
            <div className="detail">
              <h3>Klinik Psikolog Meltem OK</h3>
              <article>
                Konu : Psikodinamik açıdan anorgazmi ve tedavi yöntemleri
              </article>
              <h3>Op.Dr. Selcan BAHADIR</h3>
              <article>
                Konu : Jineseksolojik açıdan orgazm ve anorgazmi
              </article>
            </div>
          ),
        },
      ],
    },
  },
  {
    category: {
      id: 10,
      name: "2020",
      imgsrc: [process.env.PUBLIC_URL + "/images/category/2020.jpeg"],
      content:
        "Kuru Kimyevi Tozlu, Karbondioksitli, Köpüklü, Sulu yangın söndürme cihazları.",
      link: "/category/2020/10/subcategories",
      subcategories: [
        {
          id: 0,
          name: "Şubat",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2020-Subat/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2020-Subat/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2020-Subat/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2020-Subat/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2020-Subat/5.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2020-Subat/6.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2020-Subat/7.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2020-Subat/8.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2020-Subat/9.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2020-Subat/10.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2020-Subat/11.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2020-Subat/12.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2020-Subat/13.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2020-Subat/14.jpg",
          ],

          content: "",
          link: "/product/10/0/subat",
          detail: (
            <div className="detail">
              <h3>Doç.Dr. Şafak OLGAN Psikolog Meltem OK</h3>
              <article>
                Konu : Tekrarlayan gebelik kaybı: Klavuzlarda son durum
              </article>
              <h3>Doç.Dr. Emre G. PABUÇCU</h3>
              <article>Konu : Luteal faz desteği: Püf noktalar</article>
            </div>
          ),
        },
      ],
    },
  },
  {
    category: {
      id: 12,
      name: "2022",
      imgsrc: [process.env.PUBLIC_URL + "/images/category/2022.jpeg"],
      content:
        "Kuru Kimyevi Tozlu, Karbondioksitli, Köpüklü, Sulu yangın söndürme cihazları.",
      link: "/category/2022/12/subcategories",
      subcategories: [
        {
          id: 0,
          name: "Nisan",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2022-Nisan/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2022-Nisan/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2022-Nisan/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2022-Nisan/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2022-Nisan/5.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2022-Nisan/6.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2022-Nisan/7.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2022-Nisan/8.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2022-Nisan/9.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2022-Nisan/10.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2022-Nisan/11.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2022-Nisan/12.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2022-Nisan/13.jpg",
          ],

          content: "",
          link: "/product/12/0/nisan",
          detail: (
            <div className="detail">
              <h3>Doç. Dr. Sezcan MÜMÜŞOĞLU</h3>
              <article>
                Konu : Overyan Stimunasyonun İzlemi,Ultrason ve Hormonlar; neye
                ne kadar bakmak yeterli?
              </article>
              <h3>Doç. Dr. Derman BAŞARAN</h3>
              <article>Konu : Endometrial Hiperplazin Yönetimi</article>
            </div>
          ),
        },
      ],
    },
  },
  {
    category: {
      id: 13,
      name: "2023",
      imgsrc: [process.env.PUBLIC_URL + "/images/category/2023.jpeg"],
      content:
        "Kuru Kimyevi Tozlu, Karbondioksitli, Köpüklü, Sulu yangın söndürme cihazları.",
      link: "/category/2023/13/subcategories",
      subcategories: [
        {
          id: 0,
          name: "Ocak",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Ocak/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Ocak/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Ocak/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Ocak/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Ocak/5.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Ocak/6.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Ocak/7.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Ocak/8.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Ocak/9.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Ocak/10.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Ocak/11.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Ocak/12.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Ocak/13.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Ocak/14.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Ocak/15.jpg",
          ],

          content: "",
          link: "/product/13/0/ocak",
          detail: (
            <div className="detail">
              <h3>Prof. Dr. Somer Cem ATABEKOĞLU</h3>
              <article>
                Konu : Beklenmeyen Düşük ve Yüksek Yanıtlı Hastalarda KOH
                Yönetimi
              </article>
              <h3>Prof. Dr. Murat SÖNMEZER</h3>
              <article>Konu : Fertilite Prezervasyonunda Güncel Durum</article>
            </div>
          ),
        },
        {
          id: 1,
          name: "Şubat",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Subat/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Subat/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Subat/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Subat/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Subat/5.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Subat/6.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Subat/7.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Subat/8.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Subat/9.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Subat/10.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Subat/11.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Subat/12.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Subat/13.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Subat/14.jpg",
          ],

          content: "",
          link: "/product/13/1/subat",
          detail: (
            <div className="detail">
              <h3>Prof. Dr. Erbil DOĞAN</h3>
              <article>
                Konu : Konjenital Uterin Anomaliler ve İnfertilite
              </article>
              <h3>Doç. Dr. Sefa KURT</h3>
              <article>Konu : Anormal Sitolojiye Yaklaşım</article>
            </div>
          ),
        },
        {
          id: 2,
          name: "Nisan",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Nisan/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Nisan/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Nisan/3.png",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Nisan/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Nisan/5.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Nisan/6.jpg",
          ],

          content: "",
          link: "/product/13/2/nisan",
          detail: (
            <div className="detail">
              <h3>Prof. Dr. Turan ÇETİN</h3>
              <article>
                Konu : Üreme Tedavilerinde Tuba Uterina: Yeterince hakim miyiz?
              </article>
              <h3>Prof. Dr. Hasan SERDAROĞLU</h3>
              <article>
                Konu : Türkiyede Tıp Eğitimi ve Uygulamada Geçmiş, Güncel Durum
                ve Olası Hedefler
              </article>
            </div>
          ),
        },
        {
          id: 3,
          name: "Ekim",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Ekim/1.png",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Ekim/2.png",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Ekim/3.png",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Ekim/4.png",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Ekim/5.png",
          ],

          content: "",
          link: "/product/13/3/ekim",
          detail: (
            <div className="detail">
              <h3>Prof. Dr. Alev ÖZER</h3>
              <article>Konu : Tekrarlayan Vulvovajinit Tedavisi</article>
              <h3>Doç. Dr. Oya Soylu KARAPINAR</h3>
              <article>Konu : Deprem ve Kadın Sağlığı</article>
            </div>
          ),
        },
        {
          id: 4,
          name: "Kasım",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Kasim/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Kasim/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Kasim/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Kasim/4.jpg",
          ],

          content: "",
          link: "/product/13/4/kasim",
          detail: (
            <div className="detail">
              <h3>Ahmet Turgay FİŞEKÇİ</h3>

              <h3>Hakan SAVLI</h3>
            </div>
          ),
        },
        {
          id: 5,
          name: "Aralık",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Aralik/1.jpeg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Aralik/2.jpeg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Aralik/3.jpeg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2023-Aralik/4.jpeg",
          ],

          content: "",
          link: "/product/13/5/aralik",
          detail: (
            <div className="detail">
              <h3>Prof. Dr. Engin ORAL</h3>
              <article>Konu : Endometrioziste İnfertilite Yönetimi</article>
              <h3>Prof. Dr. Ümit İNCEBOZ</h3>
              <article>Konu : Adölesan Endometriozis: Tanıdan Tedaviye</article>
            </div>
          ),
        },
      ],
    },
  },
  {
    category: {
      id: 14,
      name: "2024",
      imgsrc: [process.env.PUBLIC_URL + "/images/category/2024.jpeg"],
      content:
        "Kuru Kimyevi Tozlu, Karbondioksitli, Köpüklü, Sulu yangın söndürme cihazları.",
      link: "/category/2024/14/subcategories",
      subcategories: [
        {
          id: 0,
          name: "Şubat",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2024-Subat/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2024-Subat/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2024-Subat/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2024-Subat/4.jpg",
          ],

          content: "",
          link: "/product/14/0/subat",
          detail: (
            <div className="detail">
              <h3>Prof. Dr. Paşa GÖKTAŞ</h3>
              <article>
                Konu : Cinsel Yolla Bulaşan Hastalıklarda PCR Panelleri
              </article>
              <h3>Doç. Dr. Mehmet SARIER</h3>
              <article>Konu : Ürolojik Açıdan HPV ve Akut Üretrit</article>
            </div>
          ),
        },
        {
          id: 1,
          name: "Mart",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2024-Mart/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2024-Mart/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2024-Mart/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2024-Mart/4.jpg",
          ],

          content: "",
          link: "/product/14/1/Mart",
          detail: (
            <div className="detail">
              <h3>Doç. Dr. And YAVUZ</h3>
              <article>
                Konu : Servikal Serklaj : Zamanlama, Endikasyon, Teknik
              </article>
              <h3>Op. Dr. Berkan SAYAL</h3>
              <article>
                Konu : Preterm Eylem Yönetiminde Tokolitik Tedaviler Ve
                Antenatal Steroid Uygulamaları
              </article>
            </div>
          ),
        },
        {
          id: 2,
          name: "Mayıs",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2024-Mayis/1.png",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2024-Mayis/2.png",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2024-Mayis/3.png",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2024-Mayis/4.png",
          ],

          content: "",
          link: "/product/14/2/Mayis",
          detail: (
            <div className="detail">
              <h3>Dr. Demet BAŞER</h3>
              <article>Konu : KAHEV ve Burslar</article>
              <h3>Dr. Esra TAMBURACI</h3>
              <article>Konu : Menopoza Güncel Yaklaşımlar</article>
            </div>
          ),
        },
        {
          id: 3,
          name: "Aralık",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2024-Aralik/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2024-Aralik/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2024-Aralik/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2024-Aralik/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2024-Aralik/5.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2024-Aralik/6.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2024-Aralik/7.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2024-Aralik/8.jpg",
          ],

          content: "",
          link: "/product/14/3/aralik",
          detail: (
            <div className="detail">
              <h3>Doç.Dr. Erhan Şimşek</h3>
              <article>
                Konu : Sosyal Amaçlı Oosit Dondurma: Kime ve Ne Zaman
                Önerilmeli?
              </article>
              <h3>Doç.Dr. Mehmet Murat Işıkalan</h3>
              <article>
                Konu : Multifetal Gebelik Redüksiyonu; Endikasyonlar ve
                Zamanlama Nasıl Olmalıdır?
              </article>
            </div>
          ),
        },
      ],
    },
  },
  {
    category: {
      id: 15,
      name: "2025",
      imgsrc: [process.env.PUBLIC_URL + "/images/category/2025.jpg"],
      content:
        "Kuru Kimyevi Tozlu, Karbondioksitli, Köpüklü, Sulu yangın söndürme cihazları.",
      link: "/category/2025/15/subcategories",
      subcategories: [
        {
          id: 0,
          name: "Şubat",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Subat/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Subat/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Subat/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Subat/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Subat/5.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Subat/6.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Subat/7.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Subat/8.jpg",
          ],

          content: "",
          link: "/product/15/0/subat",
          detail: (
            <div className="detail">
              <h3>Prof. Dr. Berfu Demir</h3>
              <article>
                Konu : Ovülasyon İndüksiyonunda Sıradışı Olguların Yönetimi
              </article>
              <h3>Prof. Dr. Murat Sönmezer</h3>
              <article>
                Konu : Ovaryen Gençleştirme (Rejuvenation) mümkün müdür?
              </article>
            </div>
          ),
        },
        {
          id: 1,
          name: "Nisan",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Nisan/2.jpeg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Nisan/1.jpeg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Nisan/3.jpeg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Nisan/4.jpeg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Nisan/5.jpeg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Nisan/6.jpeg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Nisan/7.jpeg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Nisan/8.jpeg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Nisan/9.jpeg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Nisan/10.jpeg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Nisan/11.jpeg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Nisan/12.jpeg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Nisan/13.jpeg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Nisan/14.jpeg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Nisan/15.jpeg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Nisan/16.jpeg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Nisan/17.jpeg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Nisan/18.jpeg",
          ],

          content: "",
          link: "/product/15/1/nisan",
          detail: (
            <div className="detail">
              <h3>Prof. Dr. Erol Tavmergen</h3>
              <article>Konu : Üreme Tedavisinde İntramural Miyomlar</article>
              {/* <h3>Prof. Dr. Murat Sönmezer</h3>
                        <article>Konu : Ovaryen Gençleştirme (Rejuvenation) mümkün müdür?</article> */}
            </div>
          ),
        },
        {
          id: 2,
          name: "Ekim",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Ekim/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Ekim/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Ekim/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Ekim/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Ekim/5.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Ekim/6.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Ekim/7.jpg",
          ],

          content: "",
          link: "/product/15/2/ekim",
          detail: (
            <div className="detail">
              <h3>Prof. Dr. Nasuh Utku Doğan</h3>
              <article>Konu : Laparoskopide Komplikasyonlardan Kaçınma</article>
              <h3>Doç. Dr. Mete Işıkoğlu</h3>
              <article>
                Konu : Konvansiyonel IVF Nedir?
              </article>
            </div>
          ),
        },
         {
          id: 3,
          name: "Aralık",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Aralik/1.png",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Aralik/2.png",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Aralik/3.png",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Aralik/4.png",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Aralik/5.png",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Aralik/6.png",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Aralik/7.png",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Aralik/8.png",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2025-Aralik/9.png",
          ],

          content: "",
          link: "/product/15/3/Aralık",
          detail: (
            <div className="detail">
              <h3>Prof. Dr. Yaprak Üstün</h3>
              <article>Konu : Menopozda hormon replasman tedavisinin incelikleri</article>
              <h3>Prof. Dr. Yusuf Üstün</h3>
              <article>
                Konu : Adölesan PKOS: Tanı ve Tedavide devam eden bilmeceler 
              </article>
            </div>
          ),
        },
      ],
    },
  },
    {
    category: {
      id: 26,
      name: "2026",
      imgsrc: ["https://gelecektupbebek.com.tr/images/category/2026.png"],
      content:
        "Kuru Kimyevi Tozlu, Karbondioksitli, Köpüklü, Sulu yangın söndürme cihazları.",
      link: "/category/2026/26/subcategories",
      subcategories: [
        {
          id: 0,
          name: "Şubat",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2026-Subat/1.png",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2026-Subat/2.png",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2026-Subat/3.png",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2026-Subat/4.png",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2026-Subat/5.png",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2026-Subat/6.png",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2026-Subat/7.png",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2026-Subat/8.png",
          ],

          content: "",
          link: "/product/26/0/subat",
          detail: (
            <div className="detail">
              <h3>Prof. Dr. Süleyman Engin Akhan</h3>
              <article>
                Konu : Genital HPV Son Değişiklikler
              </article>
              <h3>Prof. Dr. Murat Berkkanoğlu</h3>
              <article>
                Konu : HPV Aşısı ve İnfertilite İlişkisi
              </article>
            </div>
          ),
        },
        {
          id: 1,
          name: "Ekim",
          imgsrc: [
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2026-Ekim/1.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2026-Ekim/2.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2026-Ekim/3.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2026-Ekim/4.jpg",
            process.env.PUBLIC_URL + "/eski/Etkinlikler/2026-Ekim/5.jpg",
          ],
          content: "",
          link: "/product/26/1/ekim",
          detail: (
            <div className="detail">
              <h3>
                TÜRKİYE’DE FERTİLİTENİN SESSİZ ÇÖKÜŞÜ: Nedenler, Sonuçlar ve Olası Çözümler
              </h3>
            </div>
          ),
        },
      ],
    },
  },
];

export default data;
